export default __webpack_public_path__ + "static/media/home_root_background.013f5667.jpg";